var map = {
	"./demos/attachments/index.ts": 90595,
	"./demos/basic/index.ts": 26859,
	"./demos/beforeInput/index.ts": 56018,
	"./demos/configure/index.ts": 58956,
	"./demos/custom/index.ts": 76495,
	"./demos/customAttachment/index.ts": 99708,
	"./demos/directory/index.ts": 67524,
	"./demos/drag/index.ts": 25333,
	"./demos/generating/index.ts": 24036,
	"./demos/headerFooter/index.ts": 51186,
	"./demos/image/index.ts": 44879,
	"./demos/methods/index.ts": 58296,
	"./demos/pasteFile/index.ts": 39493,
	"./demos/prefix/index.ts": 9889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46505;